/* KRAFTKÖNIG (27.10.2026): Pfeile links/rechts am großen Produktbild – blättert zum vorherigen/nächsten Bild.
   Computer (Vorschaubild-Leiste): schaltet über die Theme-Galerie um und markiert das Vorschaubild.
   Handy (Wisch-Slider): scrollt zum nächsten Bild. Am Ende geht es wieder zum ersten. */
(function () {
  var PFEIL = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var desktop = window.matchMedia('(min-width: 750px)');

  function einrichten(galerie) {
    if (galerie.dataset.kkPfeile) return;
    var viewer = galerie.querySelector('[id^="GalleryViewer"]');
    var liste = viewer && viewer.querySelector('.product__media-list');
    if (!liste) return;
    var bilder = function () { return Array.prototype.slice.call(liste.querySelectorAll(':scope > [data-media-id]')); };
    if (bilder().length < 2) return;
    galerie.dataset.kkPfeile = '1';
    viewer.classList.add('kk-galerie');

    function aktuell() {
      var b = bilder();
      if (desktop.matches && galerie.elements && galerie.elements.thumbnails) {
        var i = b.findIndex(function (el) { return el.classList.contains('is-active'); });
        return i < 0 ? 0 : i;
      }
      var best = 0, abst = Infinity;
      b.forEach(function (el, i) { var d = Math.abs(el.offsetLeft - liste.offsetLeft - liste.scrollLeft); if (d < abst) { abst = d; best = i; } });
      return best;
    }

    function gehe(richtung) {
      var b = bilder();
      var ziel = b[(aktuell() + richtung + b.length) % b.length];
      if (desktop.matches && galerie.elements && galerie.elements.thumbnails && galerie.setActiveMedia) {
        galerie.setActiveMedia(ziel.dataset.mediaId, false);
      } else {
        liste.scrollTo({ left: ziel.offsetLeft - liste.offsetLeft, behavior: 'smooth' });
      }
    }

    [['prev', 'Vorheriges Bild', -1], ['next', 'Nächstes Bild', 1]].forEach(function (p) {
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'kk-galerie__pfeil kk-galerie__pfeil--' + p[0];
      knopf.setAttribute('aria-label', p[1]);
      knopf.innerHTML = PFEIL;
      knopf.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); gehe(p[2]); });
      viewer.appendChild(knopf);
    });

    // Pfeile mittig auf das Bild setzen (die Zähler-Leiste darunter nicht mitrechnen)
    function position() { viewer.style.setProperty('--kk-pfeil-top', (liste.offsetTop + liste.offsetHeight / 2) + 'px'); }
    position();
    window.addEventListener('resize', position);
    if (window.ResizeObserver) new ResizeObserver(position).observe(liste);
  }

  function alle() { document.querySelectorAll('media-gallery').forEach(einrichten); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  window.addEventListener('load', alle);
})();
